export const KEYS = {
  TOKEN: 'token',
  EXPIRY_DATE: 'expiryDate',
};
